import Animation from 'component/Animation'
import styled from 'styled-components'
import pagePullLoadingStyle from './page-pull-load/style'
import pagePullLoadAnimation from './page-pull-load'

export const PagePullLoadIcon = styled(Animation).attrs({ animationData: pagePullLoadAnimation })`
  ${pagePullLoadingStyle}
`

export default PagePullLoadIcon
